import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import FeaturePermission from "./FeaturePermission";

const Features = (props) => {
  const {
    getFeatureList,
    getClientSetting,
    updateClientSetting,
    createIllustoAccount,
    getEntityDetails,
    entityConfig,
  } = props;

  const { id } = useParams();

  const [masterPermissionSet, setMasterPermissionSet] = useState([]); //master collection of features
  const [allowedPermission, setAllowedPermission] = useState({}); //features opted by organization
  const [categoryArray, setCategoryArray] = useState([]);
  const [loader, setLoader] = useState(false);

  const antIcon = useMemo(() => {
    <LoadingOutlined style={{ fontSize: 24 }} spin />;
  }, []);

  const updateFeatureList = async () => {
    const { value } = await getFeatureList({ id });
    setMasterPermissionSet(value?.data || []);
    let categoryArr = [];
    value?.data.map((e) => {
      if (!categoryArr.includes(e?.category)) {
        categoryArr.push(e?.category);
        return categoryArr.sort();
      }
    });
    setCategoryArray(categoryArr);
  };

  const updateClientSettings = async () => {
    let payload = {
      entityId: id,
      permissions: allowedPermission,
    };
    const { value } = await updateClientSetting(payload);
    if (value?.status) {
      notification["success"]({ message: value?.message });
      fetchClientSetting();
    } else {
      notification["error"]({ message: value?.message });
    }
  };
  const fetchClientSetting = async () => {
    const { value } = await getClientSetting({ entityId: id });
    setAllowedPermission(value?.data?.permissions);
  };

  useEffect(() => {
    if (id) {
      updateFeatureList();
      fetchClientSetting();
    }
  }, [id]);

  const addIllustoAccount = async () => {
    setLoader(true);
    let payload = {
      entityId: id,
    };
    const { value } = await createIllustoAccount(payload);
    if (value.status) {
      notification["success"]({ message: value?.message, style: { textTransform: "capitalize" } });
      getEntityDetails();
      setLoader(false);
    } else {
      notification["error"]({ message: value?.message, style: { textTransform: "capitalize" } });
      setLoader(false);
    }
  };

  return (
    <>
      {/* <AccessControl code="permission_settings" page="profile"> */}
      <div className="features-container bg-white">
        {/* <h5>Features</h5> */}
        <div className="title-block--op">
          <h4>Features</h4>
          {entityConfig?.permissions?.advanceEditor && (
            <div className="page-toolbar-styled">
              <div className="page-toolbar-styled-item">
                <button
                  disabled={entityConfig?.illusto?.accountId && entityConfig?.illusto?.accountSecret}
                  className="btn btn-primary"
                  onClick={() => addIllustoAccount()}
                >
                  {loader ? <Spin className="lightLoader-spin" indicator={antIcon} /> : "Create illusto account"}
                </button>
              </div>
            </div>
          )}
        </div>
        <FeaturePermission
          {...props}
          allowedPermission={allowedPermission}
          setAllowedPermission={setAllowedPermission}
          updateClientSettings={updateClientSettings}
          masterPermissionSet={masterPermissionSet}
          categoryArray={categoryArray}
        />
      </div>
    </>
  );
};

export default Features;
